// FIXME: Está biblioteca está incompleta e não foi muito bem projetada por
// fatore de tempo.

import store from '@/store'

export const TimerStatusEnum = {
  NOT_STARTED: 0,
  STARTED: 1,
  PAUSED: 2,
  EXPIRED : 3
}

export default class Timer {
  static interval = null

  static start(time = 60) {
    if (
      store.state.timerStatus === TimerStatusEnum.NOT_STARTED
      || store.state.timerStatus === TimerStatusEnum.PAUSED
    ) {
      Timer.setTime(time)
      Timer.setStatus(TimerStatusEnum.STARTED)
      Timer.startTic()
      return true
    } else {
      return false
    }
  }

  static startTic() {
    Timer.interval = setInterval(() => {
      Timer.tic()
    }, 1000)
  }

  static tic() {
    if (store.state.timerStatus !== TimerStatusEnum.STARTED) {
      Timer.stopTic()
      return
    }

    if (store.state.timerCounter === 0) {
      Timer.expire()
      return
    }

    Timer.decrementCounter()
  }

  static stopTic() {
    clearInterval(Timer.interval)
    Timer.interval = null
  }

  static expire() {
    Timer.setStatus(TimerStatusEnum.EXPIRED)
    Timer.stopTic()
  }

  static decrementCounter() {
    Timer.setTime(store.state.timerCounter - 1)
  }

  static isNotStarted() {
    return (store.state.timerStatus === TimerStatusEnum.NOT_STARTED)
  }

  static isExpired() {
    return (store.state.timerStatus === TimerStatusEnum.EXPIRED)
  }

  static setTime(time) {
    store.dispatch('timerCounter', time)
  }

  static setStatus(status) {
    store.dispatch('timerStatus', status)
  }
}